import {useEffect, useRef} from 'react';
import {createConsumer} from '@rails/actioncable';
import store from '~/redux/store';
import {CABLE_URL} from '~/constants/env';

export interface TimerSyncData {
  action: string;
}

export default function useAppointmentTimerSync(
  appointmentId: number | string | undefined,
  onRealtimeDataChange: (data: TimerSyncData) => void
) {
  const cableRef = useRef<ReturnType<typeof createConsumer> | null>(null);
  const state = store.getState();
  const token = state.auth.token;

  useEffect(() => {
    if (!appointmentId) return;

    cableRef.current = createConsumer(CABLE_URL);
    let _subscription: unknown = null;

    _subscription = cableRef.current.subscriptions.create(
      {
        channel: 'AppointmentCheckoutChannel',
        appointment_id: appointmentId,
        token: token,
      },
      {
        received(data: TimerSyncData) {
          if (data.action === 'stop_timer') {
            onRealtimeDataChange(data);
          }
          if (data.action === 'checkout_patient') {
            onRealtimeDataChange(data);
          }
        },
      }
    );

    return () => {
      if (
        _subscription &&
        typeof (_subscription as {unsubscribe?: () => void}).unsubscribe ===
          'function'
      ) {
        (_subscription as {unsubscribe: () => void}).unsubscribe();
      }
      if (cableRef.current) {
        cableRef.current.disconnect();
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [appointmentId]);
}
